module.exports = __webpack_public_path__ + "img/resistance.52ec60ff.jpg";